import { ProgressCircle } from 'components/progress-circle'
import firecrackerLogo from 'img/logo_firecracker-cropped.svg'
import styles from 'css/components/loading-modal.module.css'

interface LoadingModalProps {
    message?: string
    children?: React.ReactNode
}

export const LoadingModal = ({ message, children }: LoadingModalProps) => (
	<div className="overlay">
		<div className={`overlay-content-container ${styles.loadingModal}`}>
			<img src={firecrackerLogo} alt="Loading" className={styles.loadingLogo} />
			<div className={styles.generatingText}>
				{children || message}
				<ProgressCircle size="large" />
				<div className={styles.pleaseWait}>Please wait...</div>
			</div>
		</div>
	</div>
);

